
  <!-- FILTER SUPERIOR TITULO + BUSCADOR + FILTER -->

<aside [ngClass]="{'navigation-filter--white': color === 'white', 'sidebar-collapsed': collapsed}"
  class="sidebar-filters hidden md:block flex-shrink-0 self-start  bg-white rounded-lg box-cards transition-all duration-300 overflow-hidden">

  <!-- Header -->
  <div class="flex items-center  pt-5 pb-4" [ngClass]="collapsed ? 'px-2 justify-center' : 'px-5 justify-between'">
    <div class="flex items-center gap-2" *ngIf="!collapsed">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="w-4 h-4 text-gray-400 flex-shrink-0">
        <line x1="21" x2="14" y1="4" y2="4"></line>
        <line x1="10" x2="3" y1="4" y2="4"></line>
        <line x1="21" x2="12" y1="12" y2="12"></line>
        <line x1="8" x2="3" y1="12" y2="12"></line>
        <line x1="21" x2="16" y1="20" y2="20"></line>
        <line x1="12" x2="3" y1="20" y2="20"></line>
        <line x1="14" x2="14" y1="2" y2="6"></line>
        <line x1="8" x2="8" y1="10" y2="14"></line>
        <line x1="16" x2="16" y1="18" y2="22"></line>
      </svg>
      <span class="text-[13px]  font-semibold text-gray-500 uppercase tracking-wider">{{ 'words.filters' | translate
        }}</span>
    </div>
    <!-- ── RESET ── -->
    <div class="flex flex-row gap-3">
      <!--
      <div *ngIf="activeFilters" style="display: none !important;">
        <button type="button"
          class="w-full text-[13px]  text-secondary-500 hover:text-secondary-700 flex items-center gap-1.5 py-1.5 transition-colors"
          (click)="onFilterReset(); modalFilters.onReset()">
          <i class="fas fa-sync-alt text-[13px] "></i>
        </button>
      </div>-->

      <!-- ── BUTTON COLLAPSE ── -->
      <button type="button" (click)="toggleCollapsed()"
        class="flex items-center justify-center w-6 h-6 rounded-full border border-gray-200 text-gray-400 hover:bg-secondary-500 hover:bg-gray-100 transition-colors flex-shrink-0"
        [title]="collapsed ? 'Expandir filtros' : 'Comprimir filtros bg-gray-100'">
        <i class="icon text-sm leading-none" [ngClass]="collapsed ? 'icon-arrow-ios-right' : 'icon-arrow-ios-left'"></i>
      </button>
    </div>
  </div>
  
  <!-- ICONS filtros -->
  <!-- ── Collapsed: iconos de cada sección de filtro ── -->
  <div *ngIf="collapsed" class="px-2 pb-4 flex flex-col items-center gap-0.5">
    <!-- Inscripción (oculto: movido al search-sort-bar como switcher) -->
    <div *ngIf="type === 'catalogue'" class="hidden"
      [ngClass]="subscriptionFilter ? 'text-secondary-500' : 'text-gray-400 hover:text-gray-600'"
      [title]="'words.state' | translate" (click)="collapsed = false; openSections['subscription'] = true">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <polyline points="16 11 18 13 22 9"></polyline>
      </svg>
    </div>

    <!-- Áreas de conocimiento -->
    <div *ngIf="availableSkills?.length > 0 && type !== 'content'"
      class="flex justify-center w-full py-2 border-b border-gray-100 cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
      [title]="'words.knowledge-areas' | translate" (click)="collapsed = false; openSections['skills'] = true">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path
          d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2">
        </path>
      </svg>
    </div>

    <!-- Tipo de contenido -->
    <div
      class="flex justify-center w-full py-2 border-b border-gray-100 cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
      [title]="'words.content-type' | translate" (click)="collapsed = false; openSections['types'] = true">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path
          d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z">
        </path>
        <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"></path>
        <path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"></path>
      </svg>
    </div>

    <!-- Proveedores / otros checkbox -->
    <ng-container *ngFor="let filter of filtersModal">
      <div *ngIf="filter.type === 'checkbox' && filter.options.length"
        class="flex justify-center w-full py-2 border-b border-gray-100 cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
        [title]="filter.label" (click)="collapsed = false; openSections[filter.name] = true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
          <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
          <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
          <path d="M10 6h4"></path>
          <path d="M10 10h4"></path>
          <path d="M10 14h4"></path>
          <path d="M10 18h4"></path>
        </svg>
      </div>
    </ng-container>

    <!-- Idiomas / multiselect -->
    <ng-container *ngFor="let filter of filtersModal">
      <div *ngIf="filter.type === 'multiselect' && filter.options.length"
        class="flex justify-center w-full py-2 border-b border-gray-100 cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
        [title]="filter.label" (click)="collapsed = false; openSections[filter.name] = true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
          <path d="M2 12h20"></path>
        </svg>
      </div>
    </ng-container>

  </div>

<!-- ACCION filtros -->
  <div class="px-5 pb-5" *ngIf="!collapsed">
    <!-- Secciones de filtros -->
    <div class="space-y-1" *ngIf="showAdvancedFilters">

      <!-- ── INSCRIPCIÓN (oculto: movido al search-sort-bar como switcher) ── -->
      <div class="hidden border-b border-gray-100 pb-2" *ngIf="type === 'catalogue'">
        <button type="button"
          class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-1.5 hover:text-primary transition-colors"
          (click)="toggleSection('subscription')">
          <span class="text-sm">{{ 'words.state' | translate }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections['subscription']">
            <path d="m6 9 6 6 6-6"></path>
          </svg>
        </button>
        <div *ngIf="openSections['subscription']" class="mt-1 space-y-0.5 ">
          <!-- Inscrito -->
          <div class="flex items-center gap-2 py-1.5 px-1.5 rounded-sm cursor-pointer transition-all"
            [style.background]="subscriptionFilter === 'subscribed' ? 'var(--v2-color-secondary-100)' : 'transparent'"
            (click)="onSubscriptionFilterChange('subscribed')">
            <span class="flex-shrink-0 w-4 h-4 rounded border-2 flex items-center justify-center transition-colors"
              [style.background-color]="subscriptionFilter === 'subscribed' ? 'var(--v2-color-secondary-500)' : 'transparent'"
              [style.border-color]="subscriptionFilter === 'subscribed' ? 'var(--v2-color-secondary-500)' : '#d1d5db'">
              <svg *ngIf="subscriptionFilter === 'subscribed'" xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round"
                stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span class="text-[13px] transition-colors"
              [ngClass]="subscriptionFilter === 'subscribed' ? 'font-medium' : 'text-gray-500'"
              [style.color]="subscriptionFilter === 'subscribed' ? 'var(--v2-color-secondary-700)' : null">
              {{ 'group.team.cards.enrolled' | translate }}
            </span>
          </div>
          <!-- No inscrito -->
          <div class="flex items-center gap-2 py-1.5 px-1.5 rounded-sm cursor-pointer transition-all"
            [style.background]="subscriptionFilter === 'not_subscribed' ? 'var(--v2-color-secondary-100)' : 'transparent'"
            (click)="onSubscriptionFilterChange('not_subscribed')">
            <span class="flex-shrink-0 w-4 h-4 rounded border-2 flex items-center justify-center transition-colors"
              [style.background-color]="subscriptionFilter === 'not_subscribed' ? 'var(--v2-color-secondary-500)' : 'transparent'"
              [style.border-color]="subscriptionFilter === 'not_subscribed' ? 'var(--v2-color-secondary-500)' : '#d1d5db'">
              <svg *ngIf="subscriptionFilter === 'not_subscribed'" xmlns="http://www.w3.org/2000/svg" width="10"
                height="10" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round"
                stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span class="text-[13px] transition-colors"
              [ngClass]="subscriptionFilter === 'not_subscribed' ? 'font-medium' : 'text-gray-500'"
              [style.color]="subscriptionFilter === 'not_subscribed' ? 'var(--v2-color-secondary-700)' : null">
              {{ 'words.not-subscribed' | translate }}
            </span>
          </div>
        </div>
      </div>

      <!-- ── Áreas de conocimiento ── -->
      <div class="border-b border-gray-100 pb-2" *ngIf="availableSkills?.length > 0 && type !== 'content'">
        <button type="button"
          class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-1.5 hover:text-primary transition-colors"
          (click)="toggleSection('skills')">
          <span class="text-sm">{{ 'words.knowledge-areas' | translate }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections['skills']">
            <path d="m6 9 6 6 6-6"></path>
          </svg>
        </button>
        <div *ngIf="openSections['skills']" class="mt-1 space-y-0.5 ">
          <label *ngFor="let skill of (expandedSections['skills'] ? availableSkills : availableSkills.slice(0, 8))"
            class="flex items-center gap-2 py-1.5 px-1.5 rounded-sm cursor-pointer transition-all"
            [style.background]="skill.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
            <msc-common2-checkbox [value]="skill.isSelected"
              (changeEvent)="onInlineMultiselectChange(skill, 'contentSkills', availableSkills)">
            </msc-common2-checkbox>
            <span class="text-[13px] transition-colors line-clamp-2 overflow-hidden text-ellipsis"
              [ngClass]="skill.isSelected ? 'font-medium' : 'text-gray-500'"
              [style.color]="skill.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ skill.label }}</span>
          </label>
          <button *ngIf="availableSkills?.length > 8 && !expandedSections['skills']" type="button"
            class="mt-6  pt-2 text-xs text-gray-400 hover:text-gray-600 transition-colors flex items-center gap-1"
            (click)="expandedSections['skills'] = true">
            <span>+ {{ 'words.see-more' | translate }}</span>
          </button>
          <button *ngIf="availableSkills?.length > 8 && expandedSections['skills']" type="button"
            class="mt-6  pt-2 text-xs text-gray-400 hover:text-gray-600 transition-colors flex items-center gap-1"
            (click)="expandedSections['skills'] = false">
            <span>- {{ 'words.see-less' | translate }}</span>
          </button>
        </div>
      </div>

      <!-- ── TIPO DE CONTENIDO ── -->
      <div class="border-b border-gray-100 pb-2">
        <button type="button"
          class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-1.5 hover:text-primary transition-colors"
          (click)="toggleSection('types')">
          <span class="text-sm">{{ 'words.content-type' | translate }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections['types']">
            <path d="m6 9 6 6 6-6"></path>
          </svg>
        </button>
        <div *ngIf="openSections['types']" class="mt-1 space-y-0.5 ">
          <!-- external_content vive en availableTypes pero se oculta del UI porque
               queda fusionado con "Cursos"; el backend sigue recibiendo ambos tipos. -->
          <ng-container *ngFor="let type of availableTypes">
            <label *ngIf="type.value !== 'external_content'"
              class="flex items-center gap-2 py-1.5 px-1.5 rounded-sm cursor-pointer transition-all"
              [style.background]="type.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
              <msc-common2-checkbox [value]="type.isSelected" (changeEvent)="onSelectType(type)">
              </msc-common2-checkbox>
              <span class="text-[13px]  transition-colors line-clamp-2 overflow-hidden text-ellipsis"
                [ngClass]="type.isSelected ? 'font-medium' : 'text-gray-500'"
                [style.color]="type.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ type.label }}</span>
            </label>
          </ng-container>
        </div>
      </div>

      <!-- ── PROVEEDORES e otros checkbox (filtersModal type='checkbox') ── -->
      <ng-container *ngFor="let filter of filtersModal">
        <ng-container *ngIf="filter.type === 'checkbox' && filter.options.length">
          <div class="border-b border-gray-100 pb-2">
            <button type="button"
              class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-1.5 hover:text-primary transition-colors"
              (click)="toggleSection(filter.name)">
              <span>{{ filter.label }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections[filter.name]">
                <path d="m6 9 6 6 6-6"></path>
              </svg>
            </button>
            <div *ngIf="openSections[filter.name]" class="mt-1 space-y-0.5 ">
              <label
                *ngFor="let option of (expandedSections[filter.name] ? filter.options : filter.options.slice(0, 8))"
                class="flex items-center gap-2 py-1.5 px-1.5 rounded-sm cursor-pointer transition-all"
                [style.background]="option.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
                <msc-common2-checkbox [value]="filter.name === 'providers' ? option.isChecked : option.isSelected"
                  (changeEvent)="onInlineMultiselectChange(option, filter.name, filter.options)">
                </msc-common2-checkbox>
                <span class="text-[13px]  transition-colors line-clamp-2 overflow-hidden text-ellipsis"
                  [ngClass]="option.isSelected ? 'font-medium' : 'text-gray-500'"
                  [style.color]="option.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ option.label }}</span>
              </label>
              <button *ngIf="filter.options?.length > 8 && !expandedSections[filter.name]" type="button"
                class="mt-2 text-sm text-gray-400 hover:text-gray-600 transition-colors flex items-center gap-1"
                (click)="expandedSections[filter.name] = true">
                <span>+ {{ 'words.see-more' | translate }}</span>
              </button>
              <button *ngIf="filter.options?.length > 8 && expandedSections[filter.name]" type="button"
                class="mt-2 text-sm text-gray-400 hover:text-gray-600 transition-colors flex items-center gap-1"
                (click)="expandedSections[filter.name] = false">
                <span>- {{ 'words.see-less' | translate }}</span>
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- ── IDIOMAS (filtersModal type='multiselect') ── -->
      <ng-container *ngFor="let filter of filtersModal">
        <ng-container *ngIf="filter.type === 'multiselect' && filter.options.length">
          <div class=" border-gray-100 pb-2">
            <button type="button"
              class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-1.5 hover:text-primary transition-colors"
              (click)="toggleSection(filter.name)">
              <span>{{ filter.label }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections[filter.name]">
                <path d="m6 9 6 6 6-6"></path>
              </svg>
            </button>
            <div *ngIf="openSections[filter.name]" class="mt-1 space-y-0.5 ">
              <label *ngFor="let option of filter.options"
                class="flex items-center gap-2 py-1.5 px-1.5 rounded-sm cursor-pointer transition-all"
                [style.background]="option.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
                <msc-common2-checkbox [value]="option.isSelected"
                  (changeEvent)="onInlineMultiselectChange(option, filter.name, filter.options)">
                </msc-common2-checkbox>
                <span class="text-[13px]  transition-colors line-clamp-2 overflow-hidden text-ellipsis"
                  [ngClass]="option.isSelected ? 'font-medium' : 'text-gray-500'"
                  [style.color]="option.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ option.label }}</span>
              </label>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- ── PROGRESO / STATUS: moved to search-sort-bar pills ── -->



      <!-- ── CURSOS GUARDADOS (solo content) ── -->
      <div class=" hidden pt-1" *ngIf="type === 'content'">
        <button type="button"
          class="w-full text-sm flex items-center gap-2 py-1.5 px-1.5-gray-500 hover:text-primary transition-colors"
          (click)="navigateSavedContent()">
          <i class="flex items-center text-base"
            [ngClass]="bookmarkActive ? 'icon icon-bookmark-1' : 'icon icon-bookmark'"></i>
          <span>{{ 'words.saved' | translate }}</span>
        </button>
      </div>



      <!-- ── RESET ── -->
      <div class="pt-2 border-t border-gray-100" *ngIf="activeFilters">
        <button type="button"
          class="w-full text-[13px]  text-secondary-500 hover:text-secondary-700 flex items-center gap-1.5 py-1.5 transition-colors"
          (click)="onFilterReset(); modalFilters.onReset()">
          <i class="fas fa-sync-alt text-[13px] "></i>
          <span>{{ 'studio.re-use.reset-filter' | translate }}</span>
        </button>
      </div>

    </div>
  </div>

</aside>

<!-- ===== MOBILE FILTER DRAWER (md:hidden) ===== -->
<!-- Backdrop -->
<div *ngIf="mobileDrawerOpen"
  class="md:hidden fixed inset-0 bg-black/40 z-[200]"
  (click)="closeMobileDrawer()">
</div>
<!-- Drawer panel -->
<div *ngIf="mobileDrawerOpen"
  class="md:hidden fixed bottom-0 left-0 right-0 z-[201] bg-white rounded-t-2xl shadow-2xl flex flex-col max-h-[80vh] animate-in slide-in-from-bottom duration-300">
  <!-- Header -->
  <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
    <div class="flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-500">
        <line x1="21" x2="14" y1="4" y2="4"></line><line x1="10" x2="3" y1="4" y2="4"></line>
        <line x1="21" x2="12" y1="12" y2="12"></line><line x1="8" x2="3" y1="12" y2="12"></line>
        <line x1="21" x2="16" y1="20" y2="20"></line><line x1="12" x2="3" y1="20" y2="20"></line>
        <line x1="14" x2="14" y1="2" y2="6"></line><line x1="8" x2="8" y1="10" y2="14"></line>
        <line x1="16" x2="16" y1="18" y2="22"></line>
      </svg>
      <span class="text-base font-semibold text-gray-700">{{ 'words.filters' | translate }}</span>
    </div>
    <div class="flex items-center gap-3">
      <button *ngIf="activeFilters" type="button"
        class="text-[13px] text-secondary-500 hover:text-secondary-700 flex items-center gap-1"
        (click)="onFilterReset(); modalFilters.onReset()">
        <i class="fas fa-sync-alt text-xs"></i>
        <span>{{ 'studio.re-use.reset-filter' | translate }}</span>
      </button>
      <button (click)="closeMobileDrawer()" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Scrollable content -->
  <div class="flex-1 overflow-y-auto px-5 py-3 space-y-1">

    <!-- Áreas de conocimiento -->
    <div class="border-b border-gray-100 pb-2" *ngIf="availableSkills?.length > 0 && type !== 'content'">
      <button type="button"
        class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-2"
        (click)="toggleSection('skills')">
        <span>{{ 'words.knowledge-areas' | translate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections['skills']">
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </button>
      <div *ngIf="openSections['skills']" class="mt-1 space-y-0.5">
        <label *ngFor="let skill of (expandedSections['skills'] ? availableSkills : availableSkills.slice(0, 8))"
          class="flex items-center gap-2 py-2 px-1.5 rounded-sm cursor-pointer"
          [style.background]="skill.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
          <msc-common2-checkbox [value]="skill.isSelected"
            (changeEvent)="onInlineMultiselectChange(skill, 'contentSkills', availableSkills)">
          </msc-common2-checkbox>
          <span class="text-[14px]"
            [ngClass]="skill.isSelected ? 'font-medium' : 'text-gray-500'"
            [style.color]="skill.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ skill.label }}</span>
        </label>
        <button *ngIf="availableSkills?.length > 8 && !expandedSections['skills']" type="button"
          class="pt-2 text-xs text-secondary-500 hover:text-secondary-700"
          (click)="expandedSections['skills'] = true">
          + {{ 'words.see-more' | translate }}
        </button>
        <button *ngIf="availableSkills?.length > 8 && expandedSections['skills']" type="button"
          class="pt-2 text-xs text-secondary-500 hover:text-secondary-700"
          (click)="expandedSections['skills'] = false">
          - {{ 'words.see-less' | translate }}
        </button>
      </div>
    </div>

    <!-- Tipo de contenido -->
    <div class="border-b border-gray-100 pb-2">
      <button type="button"
        class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-2"
        (click)="toggleSection('types')">
        <span>{{ 'words.content-type' | translate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections['types']">
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </button>
      <div *ngIf="openSections['types']" class="mt-1 space-y-0.5">
        <ng-container *ngFor="let type of availableTypes">
          <label *ngIf="type.value !== 'external_content'"
            class="flex items-center gap-2 py-2 px-1.5 rounded-sm cursor-pointer"
            [style.background]="type.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
            <msc-common2-checkbox [value]="type.isSelected" (changeEvent)="onSelectType(type)">
            </msc-common2-checkbox>
            <span class="text-[14px]"
              [ngClass]="type.isSelected ? 'font-medium' : 'text-gray-500'"
              [style.color]="type.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ type.label }}</span>
          </label>
        </ng-container>
      </div>
    </div>

    <!-- Proveedores -->
    <ng-container *ngFor="let filter of filtersModal">
      <ng-container *ngIf="filter.type === 'checkbox' && filter.options.length">
        <div class="border-b border-gray-100 pb-2">
          <button type="button"
            class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-2"
            (click)="toggleSection(filter.name)">
            <span>{{ filter.label }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections[filter.name]">
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </button>
          <div *ngIf="openSections[filter.name]" class="mt-1 space-y-0.5">
            <label *ngFor="let option of (expandedSections[filter.name] ? filter.options : filter.options.slice(0, 8))"
              class="flex items-center gap-2 py-2 px-1.5 rounded-sm cursor-pointer"
              [style.background]="option.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
              <msc-common2-checkbox [value]="filter.name === 'providers' ? option.isChecked : option.isSelected"
                (changeEvent)="onInlineMultiselectChange(option, filter.name, filter.options)">
              </msc-common2-checkbox>
              <span class="text-[14px]"
                [ngClass]="option.isSelected ? 'font-medium' : 'text-gray-500'"
                [style.color]="option.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ option.label }}</span>
            </label>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Idiomas -->
    <ng-container *ngFor="let filter of filtersModal">
      <ng-container *ngIf="filter.type === 'multiselect' && filter.options.length">
        <div class="pb-2">
          <button type="button"
            class="flex items-center justify-between w-full text-sm font-semibold text-gray-700 py-2"
            (click)="toggleSection(filter.name)">
            <span>{{ filter.label }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-gray-400 transition-transform duration-200" [class.rotate-180]="openSections[filter.name]">
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </button>
          <div *ngIf="openSections[filter.name]" class="mt-1 space-y-0.5">
            <label *ngFor="let option of filter.options"
              class="flex items-center gap-2 py-2 px-1.5 rounded-sm cursor-pointer"
              [style.background]="option.isSelected ? 'var(--v2-color-secondary-100)' : 'transparent'">
              <msc-common2-checkbox [value]="option.isSelected"
                (changeEvent)="onInlineMultiselectChange(option, filter.name, filter.options)">
              </msc-common2-checkbox>
              <span class="text-[14px]"
                [ngClass]="option.isSelected ? 'font-medium' : 'text-gray-500'"
                [style.color]="option.isSelected ? 'var(--v2-color-secondary-700)' : null">{{ option.label }}</span>
            </label>
          </div>
        </div>
      </ng-container>
    </ng-container>

  </div>

  <!-- Footer: Apply button -->
  <div class="px-5 py-4 border-t border-gray-100">
    <button type="button"
      class="w-full h-11 rounded-full text-sm font-semibold text-white transition-colors"
      style="background-color: var(--v2-color-secondary-500);"
      (click)="closeMobileDrawer()">
      {{ 'words.apply' | translate }}
    </button>
  </div>
</div>

<msc-filters-modal #modalFilters [filters]="filtersModal" (saveEvent)="onFilterSave($event)"></msc-filters-modal>